import styled, { css } from 'styled-components';
import PlayLinkContainer from '../../components/Link/PlayLinkContainer';
import { device } from '../breakpoints';
import {
    extraLightCoolGrey,
    fontWeightBold,
    playGrey15,
    playGrey20,
    regularBlack,
    regularWhite,
} from '../design-tokens';
import { playFontSize } from '../typography/helpers';
import { Uppercase } from '../typography/PlayUppercase.styles';

const backgroundColorLightTheme = 'rgba(255, 255, 255, 0.8)';

const getColors = (color, bgColor, hoverColor, isDisabled) => {
    return css`
        color: ${color};
        background-color: ${bgColor};

        ${!isDisabled &&
        css`
            &:hover {
                background-color: ${hoverColor};
            }
        `}

        &:focus {
            border-color: ${color};
        }
    `;
};

const getTheme = (theme, isDisabled) => {
    if (theme === 'light') {
        return getColors(regularBlack, backgroundColorLightTheme, regularWhite, isDisabled);
    }

    if (theme === 'white') {
        return getColors(regularBlack, regularWhite, extraLightCoolGrey, isDisabled);
    }

    return getColors(regularWhite, playGrey15, playGrey20, isDisabled);
};

export const ButtonStyles = css`
    ${getTheme('default')};
    font-weight: ${fontWeightBold};
    ${Uppercase}
    ${playFontSize(1.3)}
    border-radius: 100px;
    padding: 9px 20px;
    display: block;
    box-sizing: border-box;
    white-space: nowrap;
    cursor: pointer;
    outline: 0;
    text-decoration: none;
    border: 2px solid transparent;

    &:focus,
    &:hover,
    &:active {
        text-decoration: none;
        outline: 0;
    }
`;

export const ButtonLink = styled(PlayLinkContainer)`
    ${ButtonStyles}
    ${(props) => getTheme(props.theme, props.isDisabled)}
  
    text-align: center;

    ${(props) =>
        props.isDisabled &&
        css`
            opacity: 0.4;
        `}
    ${(props) =>
        props.isCentered &&
        css`
            @media ${device.GteSmall} {
                display: inline-block;
            }
        `}
`;

export const StyledAnchor = styled.a`
    ${ButtonStyles}
    ${(props) => getTheme(props.theme, props.isDisabled)}

    text-align: center;

    ${(props) => props.isDisabled && 'opacity: 0.4;'}
    ${(props) =>
        props.isCentered &&
        css`
            @media ${device.GteSmall} {
                display: inline-block;
            }
        `}
`;

export const StyledButton = styled.button`
    ${ButtonStyles}
    ${(props) => getTheme(props.theme, props.isDisabled)}
    text-align: center;

    ${(props) => props.isDisabled && 'opacity: 0.4;'}
    ${(props) =>
        props.isCentered &&
        css`
            @media ${device.GteSmall} {
                display: inline-block;
            }
        `}
`;

// Centers Button
export const ButtonContainer = styled.div`
    display: flex;
    @media ${device.GteSmall} {
        justify-content: center;
    }

    button {
        flex-grow: 1;
        @media ${device.GteSmall} {
            flex-grow: 0;
        }
    }
`;

export const ButtonLabel = styled.span`
    vertical-align: middle;
    line-height: 1.4;
`;
